/**
 * Delad lead-tracking-helper — EN plats för det kanoniska GA4-eventet
 * ``generate_lead`` som fyras av ordinarie kontaktformulär
 * (/, /hemsidor, /ai-chatbot-hemsida).
 *
 * Regler:
 *   • Skickas ENDAST när backend svarar accepted === true OCH lead_id finns.
 *   • Skickas exakt EN gång per lead_id (skydd mot React strict-mode /
 *     dubbla submits / återrenderingar).
 *   • Endast lead_id + form_source skickas — ingen PII.
 *   • Går via befintlig gtag om den finns; annars faller vi tillbaka på
 *     window.dataLayer så GTM/GA4-brygga fångar den.
 *   • Kraschar aldrig sidan om tracking-lagret saknas.
 *
 * OBS: /ny-hemsida har sin egen success-event-pipeline i
 * utils/nyHemsidaTracking.js (Meta Pixel Lead + eget dataLayer-event) och
 * ska inte kalla denna hjälpare — den är för de ORDINARIE kontaktformulären.
 */

const _sentLeadIds = new Set();

import { getConsent } from "@/utils/cookieConsent";

export function trackGenerateLead({ accepted, lead_id, form_source } = {}) {
  if (typeof window === "undefined") return false;
  if (accepted !== true) return false;
  if (!lead_id) return false;
  // GA4 generate_lead är ett analytics-event → kräver statistics-samtycke.
  // Köa ingenting i dataLayer utan samtycke (Basic Consent Mode).
  try {
    if (!getConsent().statistics) return false;
  } catch {
    return false;
  }
  if (_sentLeadIds.has(lead_id)) return false;
  _sentLeadIds.add(lead_id);

  const payload = {
    lead_id,
    form_source: form_source || "unknown",
  };

  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", "generate_lead", payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "generate_lead", ...payload });
    }
  } catch {
    /* aldrig krascha på tracking */
  }
  return true;
}

/** Testhjälp — nollställ intern one-shot-set. */
export function _resetForTests() {
  _sentLeadIds.clear();
}
